import { useNavigate } from 'react-router-dom'
import { AlertTriangle, ArrowLeft, Mail } from 'lucide-react'

export default function PaymentCancelPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0f1117' }} dir="rtl" lang="he">
      <div className="w-full max-w-lg text-center">
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ background: '#f59e0b20', border: '2px solid #f59e0b50' }}
        >
          <AlertTriangle size={44} style={{ color: '#fbbf24' }} />
        </div>

        <h1 className="text-2xl sm:text-3xl font-extrabold text-white mb-3">
          התשלום בוטל
        </h1>

        <p className="text-sm mb-8" style={{ color: '#9ca3af' }}>
          אם נתקלת בבעיה, אנחנו כאן לעזור.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => navigate('/whatsapp/pricing')}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-white transition-transform hover:scale-[1.02]"
            style={{ background: '#10b981' }}
          >
            <ArrowLeft size={18} />
            חזור לדף המחירים
          </button>

          <a
            href="mailto:nizan@otomator.co.il"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-medium text-sm transition-colors"
            style={{ color: '#9ca3af', border: '1px solid #2d3148' }}
          >
            <Mail size={16} />
            צור קשר
          </a>
        </div>
      </div>
    </div>
  )
}
